import { useEffect, useState } from "react";
import { themeSettingsProps } from "../theme";

const useLocalStorage = <
  T extends
    | themeSettingsProps
    | Record<string, string | number | boolean | null>
>(
  key: string,
  initialValue: T
) => {
  const [data, setData] = useState<T>(initialValue);

  useEffect(() => {
    const getData = window.localStorage.getItem(key);
    if (getData) {
      setData(JSON.parse(getData));
    }
  }, [key]);

  const storeData = (updateValue: T) => {
    setData(updateValue);
    window.localStorage.setItem(key, JSON.stringify(updateValue));
  };

  return { data, storeData };
};

export default useLocalStorage;
